// extracted by mini-css-extract-plugin
export default {"root":"AVRuBrDo96C2qySXAZVr"};